import { ID } from './id';
import { TaskPriorityOptions, TaskType } from './task-base';
import { Timestamp } from './timestamp';

export enum QueryFilterOptionKeys {
  LifeAreas = 'lifeAreas',
  Goals = 'goals',
  Ids = 'ids',
  TasksOnly = 'tasksOnly',
  ShowCompleted = 'showCompleted',
  DeadlineDeadlineStartDate = 'deadlineDeadlineStartDate',
  DeadlineDeadlineEndDate = 'deadlineDeadlineEndDate',
  HasDeadlineDeadline = 'hasDeadlineDeadline',
  NoDeadlineDeadline = 'noDeadlineDeadline',
  DeadlineStartDate = 'deadlineStartDate',
  DeadlineEndDate = 'deadlineEndDate',
  HasDeadline = 'hasDeadline',
  NoDeadline = 'noDeadline',
  NoLifeArea = 'noLifeArea',
  NoGoal = 'noGoal',
  ParentIds = 'parentIds',
  NoParentIds = 'noParentIds',
  Deleted = 'deleted',
  CompletedStartDate = 'completedStartDate',
  CompletedEndDate = 'completedEndDate',
}

export type QueryFilterOptions = {
  [QueryFilterOptionKeys.LifeAreas]?: ID[];
  [QueryFilterOptionKeys.Goals]?: ID[];
  [QueryFilterOptionKeys.Ids]?: ID[];
  [QueryFilterOptionKeys.ShowCompleted]?: boolean;
  [QueryFilterOptionKeys.TasksOnly]?: boolean;
  [QueryFilterOptionKeys.DeadlineDeadlineStartDate]?: Timestamp; // timestamp in milliseconds
  [QueryFilterOptionKeys.DeadlineDeadlineEndDate]?: Timestamp; // timestamp in milliseconds
  [QueryFilterOptionKeys.HasDeadlineDeadline]?: boolean;
  [QueryFilterOptionKeys.NoDeadlineDeadline]?: boolean;
  [QueryFilterOptionKeys.DeadlineStartDate]?: Timestamp; // timestamp in milliseconds
  [QueryFilterOptionKeys.DeadlineEndDate]?: Timestamp; // timestamp in milliseconds
  [QueryFilterOptionKeys.HasDeadline]?: boolean;
  [QueryFilterOptionKeys.NoDeadline]?: boolean;
  [QueryFilterOptionKeys.NoLifeArea]?: boolean;
  [QueryFilterOptionKeys.NoGoal]?: boolean;
  [QueryFilterOptionKeys.ParentIds]?: ID[];
  [QueryFilterOptionKeys.NoParentIds]?: boolean;
  [QueryFilterOptionKeys.Deleted]?: boolean;
  [QueryFilterOptionKeys.CompletedStartDate]?: Timestamp; // timestamp in milliseconds
  [QueryFilterOptionKeys.CompletedEndDate]?: Timestamp; // timestamp in milliseconds
};

export type DurationFilterOptions = {
  minDuration?: number; // in milliseconds (from "more than" filter)
  maxDuration?: number; // in milliseconds (from "less than" filter)
  noDuration?: boolean; // task has no duration set
  hasDuration?: boolean; // task has any duration set
};

export type TaskFilterOptions = QueryFilterOptions &
  DurationFilterOptions & {
    types?: TaskType[];
    priorities?: TaskPriorityOptions[];
    excludeIds?: ID[];
    includeTaskWithAction?: boolean;
    excludeHiddenTodoHabits?: boolean;
    // Client-side only: keep today-complete recurring tasks visible; only ended `completedAt` tasks stay hidden.
    showCompletedForDate?: boolean;
    archivedGoalIds?: ID[];
    // Goal ids that resolve (directly or via their parent chain) to a life area.
    lifeAreaLinkedGoalIds?: ID[];
    includeArchived?: boolean;
    deleted?: boolean;
    sortingMode?: string;
  };
